import { createReducer, on } from '@ngrx/store';
import {
  deferralFailure,
  deferralRequest,
  deferralSuccess,
  resetDeferralData,
} from '../actions';

export interface DeferralState {
  hasError: boolean;
  isSaving: boolean;
  isSaved: boolean;
}

export const initialState: DeferralState = {
  hasError: false,
  isSaving: false,
  isSaved: false,
};

export const deferralReducer = createReducer(
  initialState,
  on(deferralRequest, (state) => ({
    ...state,
    isSaved: false,
    isSaving: true,
    hasError: false,
  })),
  on(deferralSuccess, (state) => ({
    ...state,
    isSaved: true,
    hasError: false,
    isSaving: false,
  })),
  on(deferralFailure, (state) => ({
    ...state,
    isSaving: false,
    hasError: true,
    isSaved: false,
  })),
  on(resetDeferralData, (state) => ({
    ...state,
    isSaving: false,
    hasError: false,
    isSaved: false,
  }))
);
